import {useState,useEffect} from 'react';

const CountdownTimer=({initialHours=0,initialMinutes=0})=>{
  const [timeRemaining, setTimeRemaining]=useState(initialHours*3600+initialMinutes*60);

  useEffect(()=>{
    setTimeRemaining(initialHours*3600+initialMinutes*60);
  },[initialHours,initialMinutes]);

  useEffect(()=>{
    if(timeRemaining<=0) return;    
    const intervalId=setInterval(()=>{
      setTimeRemaining((prevTime)=>prevTime-1);
    },1000);

    return ()=>clearInterval(intervalId);
  },[timeRemaining]);

  const formatTime=(seconds)=>{
    const hours=Math.floor(seconds/3600);
    const minutes=Math.floor((seconds%3600)/60);
    return `${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}`;
  };

  return (
    <span className={timeRemaining<360?'countdown_blink':''}>{formatTime(timeRemaining)}</span>
  );
};

export default CountdownTimer;